import { useTypedParams } from '@sorare/routing';

import { RewardsEssenceLayout } from '#src/layouts/rewards/RewardsEssenceLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

const RewardsEssenceLayoutComponent = () => {
  const { tier, rarity } = useTypedParams<LayoutParams>();
  return <RewardsEssenceLayout tier={tier} rarity={rarity} />;
};
export default RewardsEssenceLayoutComponent;
